export default __webpack_public_path__ + "static/media/draw4-sound.37381092.mp3";